import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState } from '@/store';

export const useAuth = () => {
  const authState = useSelector((state: RootState) => state.auth);
  const user = useSelector((state: RootState) => state.auth.user);
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);
  const loading = useSelector((state: RootState) => state.auth.loading);
  const error = useSelector((state: RootState) => state.auth.error);
  const initialized = useSelector((state: RootState) => state.auth.initialized);
  const userId = useSelector((state: RootState) => state.auth.user?.id);
  const userEmail = useSelector((state: RootState) => state.auth.user?.email);

  return {
    authState,
    user,
    userId,
    userEmail,
    isAuthenticated,
    loading,
    error,
    initialized,
  };
};

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = <T>(selector: (state: RootState) => T): T => useSelector(selector);
